import { render, staticRenderFns } from "./ActionDial.vue?vue&type=template&id=542806f7&scoped=true"
import script from "./ActionDial.vue?vue&type=script&lang=js"
export * from "./ActionDial.vue?vue&type=script&lang=js"
import style0 from "./ActionDial.vue?vue&type=style&index=0&id=542806f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542806f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VIcon,VSpeedDial})
